<template lang="html">
  <div>
    <editor api-key="qwtvgxcwmati501oy9zae1rp0kqrubq1704bmhi325lte2gw" :init="editorConfig"
            v-model="editorData"></editor>
  </div>
</template>

<script>
  import Editor from '@tinymce/tinymce-vue'

  export default {
    props: ['id', 'data', 'type'],

    components: {
      editor: Editor
    },

    data () {
      return {
        editorData: '',
        editorConfig: {
          plugins: ['autoresize', 'autolink', 'link', 'table'],
          toolbar: 'bold italic | alignleft aligncenter alignright alignjustify | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | link',
          menubar: false
        }
      }
    },

    watch: {
      editorData () {
        this.$emit('getEditor', this.editorData, this.type)
      }
    },

    mounted () {
      setTimeout(() => {
        if (this.data) {
          this.editorData = this.data
        }
      }, 1000)
    }
  }
</script>

<style lang="scss">
  .tox-statusbar__branding {
    display: none
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/Editor.vue